var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Hardware-Hammer-Nail--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Hardware Hammer Nail Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 17h-4a1 1 0 0 0 0 2h0.45a0.26 0.26 0 0 1 0.25 0.21l0.71 4.3a0.59 0.59 0 0 0 1.17 0l0.71 -4.3a0.26 0.26 0 0 1 0.25 -0.21H23a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28 9.12A0.53 0.53 0 0 0 4.92 9a0.51 0.51 0 0 0 -0.35 0.15L0.15 13.54a0.5 0.5 0 0 0 -0.14 0.35v5.65a0.49 0.49 0 0 0 0.31 0.46 0.41 0.41 0 0 0 0.19 0 0.52 0.52 0 0 0 0.35 -0.14l7.24 -7.21a0.48 0.48 0 0 0 0 -0.7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.06 10.18a1.5 1.5 0 0 0 0 -2.12L18 7a1 1 0 0 0 -1.42 0 1 1 0 0 1 -1.41 0A1 1 0 0 1 15 5.93a1.52 1.52 0 0 0 -0.34 -1.61c-1.43 -1.44 -2 -2 -2.29 -2.25a7.75 7.75 0 0 0 -10 -0.45A1 1 0 0 0 2 2.76a1 1 0 0 0 1 0.67 5 5 0 0 1 3.69 1.45 3.51 3.51 0 0 1 0.72 0.94 0.43 0.43 0 0 1 -0.09 0.55l-1 1a0.49 0.49 0 0 0 -0.15 0.36 0.47 0.47 0 0 0 0.15 0.35l2.82 2.83a0.51 0.51 0 0 0 0.71 0l1.06 -1.06a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41 1 1 0 0 0 0 1.41l1.06 1.06a1.47 1.47 0 0 0 1.06 0.44 1.46 1.46 0 0 0 1.06 -0.44Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiy);
export default ForwardRef;